import { render, staticRenderFns } from "./GeneralInformation.vue?vue&type=template&id=2b36f705&scoped=true"
import script from "./GeneralInformation.vue?vue&type=script&lang=js"
export * from "./GeneralInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b36f705",
  null
  
)

export default component.exports